import { render, staticRenderFns } from "./goodsAgentEdit.vue?vue&type=template&id=4daabc92&"
import script from "./goodsAgentEdit.vue?vue&type=script&lang=js&"
export * from "./goodsAgentEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports